import * as type from "../types";
import { getToken, getUsername, getUserSubordination, getUserRole, getLogin, getGpsEnabled, getIsPkp } from './../../config/sessionData';

const initialState = {
    token: getToken(),
    authError: false,
    username: getUsername(),
    nonAdminUser: getUserSubordination(),
    role: getUserRole(),
    login: getLogin(),
    isUserBlocked: false,
    isUserExpired: false,
    isGpsEnabled: getGpsEnabled(),
    forcePasswordChange: false,
    repeatedPassword: false,
    forcePasswordChangeMessage: "",
    isPKP: getIsPkp(),
};

export default function(state = initialState,action) {
    switch(action.type) {
        case type.AUTH_SUCCEEDED:
            return {
                ...state,
                token: action.value,
                nonAdminUser: action.noAdmin,
                role: action.role,
                login: action.login,
                isGpsEnabled: action.isGpsEnabled,
                forcePasswordChange: action.forcePasswordChange,
                isPKP: action.pkp
            };
        case type.AUTH_FAILED:
            return {
                ...state,
                token: null,
                authError: true
            };
        case type.LOGOUT:
            return {
                ...state,
                token: null,
                username: "",
                nonAdminUser: true,
                login: "",
                isGpsEnabled: false
            };
        case type.ASSIGN_USERNAME:
            return {
                ...state,
                username: action.value
            };
        case type.SET_USER_BLOCKED:
            return {
                ...state,
                isUserBlocked: action.value
            };
        case type.SET_USER_EXPIRED:
            return {
                ...state,
                isUserExpired: action.value
            };
        case type.SET_FORCE_PASSWORD_CHANGE:
            return {
                ...state,
                forcePasswordChange: action.value
            };
        case type.SET_REPEATED_PASSWORD:
            return {
                ...state,
                repeatedPassword: action.value
            };
            case type.FORCE_PASSWORD_CHANGE_FAILED_MESSAGE:
                return {
                    ...state,
                    forcePasswordChangeMessage: action.value
                };
        default:
            return state;
    }
}
